import { render } from "./ContactUs.vue?vue&type=template&id=6558907a&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=6558907a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6558907a"

export default script